import { Page } from "@Types/pagify";

export const category: Page = {
  sections: [
    {
      backgroundColor: null,
      cta: [],
      description: [],
      displayType: "large_product_cards_web",
      metadata: null,
      subtitle: [
        {
          navigationLink: null,
          style: null,
          text: "Discover our range of amazing custom photo albums online and create your own dream photo book. Made with love in our workshops and printed on the finest quality photo paper for an album you’ll adore!",
        },
      ],
      tileSlugs: ["album_1", "album_2", "album_3", "album_4", "album_5"],
      title: "Album photo personnalisé",
    },
    {
      backgroundColor: null,
      cta: [],
      description: [],
      displayType: "small_colored_icons_web",
      metadata: null,
      subtitle: [],
      tileSlugs: [
        "small_colored_icons_web_quality",
        "small_colored_icons_web_customizable",
        "small_colored_icons_web_original",
      ],
      title: "L’album photo à la carte : le livre photo personnalisé by Cheerz",
    },
    {
      backgroundColor: null,
      cta: [],
      description: [],
      displayType: "seo_description_web",
      metadata: null,
      subtitle: [],
      tileSlugs: ["review-1-web", "review-2-web"],
      title: null,
    },
    {
      backgroundColor: null,
      cta: [],
      description: [],
      displayType: "faq_web",
      metadata: null,
      subtitle: [],
      tileSlugs: ["faq_web_1", "faq_web_2", "faq_web_3", "faq_web_4"],
      title: "Nos réponses à vos questions",
    },
  ],
  slug: "books",
  header: {
    text: "Collection",
    displayType: "floating",
  },
  metadata: null,
  tiles: [
    {
      slug: "album_1",
      backgroundColor: null,
      textBlock1: [
        {
          text: "Album photo couverture rigide",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock2: [
        {
          text: "à partir de",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock3: [
        {
          text: "Couverture « livre » épaisse et rigide",
          style: null,
          navigationLink: null,
        },
        {
          text: "Mise en page personnalisable",
          style: null,
          navigationLink: null,
        },
        {
          text: "Jusqu’à 150 pages",
          style: null,
          navigationLink: null,
        },
        {
          text: "Format carré, portrait ou paysages",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock4: [
        {
          text: "24,90€",
          style: null,
          navigationLink: null,
        },
      ],
      images: [
        {
          desktop: {
            "1x": "https://staging5.cheerz.com/contents/assets/web_image-aqzsjfjngy9mdpx7frqeok90srkk-2x-1.jpg",
            "2x": "https://staging5.cheerz.com/contents/assets/web_image-aqzsjfjngy9mdpx7frqeok90srkk-2x-1.jpg",
          },
          webMobile: null,
        },
      ],
      label: {
        labelType: "classic",
        text: "BESTSELLER",
        color: {
          hex: "#FFC100",
          opacityPercentage: 100,
        },
      },
      metadata: null,
      navigationLink: {
        type: "path",
        link: "products/photo-album-hardcover",
      },
      cta: null,
    },
    {
      slug: "album_2",
      backgroundColor: null,
      textBlock1: [
        {
          text: "Album photo couverture souple",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock2: [
        {
          text: "à partir de",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock3: [
        {
          text: "Couverture « revue » souple et brillante",
          style: null,
          navigationLink: null,
        },
        {
          text: "Mise en page personnalisable",
          style: null,
          navigationLink: null,
        },
        {
          text: "Jusqu’à 100 pages",
          style: null,
          navigationLink: null,
        },
        {
          text: "Format carré, portrait ou paysages",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock4: [
        {
          text: "20,90€",
          style: null,
          navigationLink: null,
        },
      ],
      images: [
        {
          desktop: {
            "1x": "https://staging5.cheerz.com/contents/assets/web_image-aqzsjfjngy9mdpx7frqeok90srkk-2x-1.jpg",
            "2x": "https://staging5.cheerz.com/contents/assets/web_image-aqzsjfjngy9mdpx7frqeok90srkk-2x-1.jpg",
          },
          webMobile: null,
        },
      ],
      label: {
        labelType: "lod",
        text: "DERNIERS JOURS",
        color: {
          hex: "#FF8CBD",
          opacityPercentage: 100,
        },
      },
      metadata: null,
      navigationLink: {
        type: "path",
        link: "products/photo-album-hardcover",
      },
      cta: null,
    },
    {
      slug: "album_3",
      backgroundColor: null,
      textBlock1: [
        {
          text: "Album photo couverture à fenêtre",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock2: [
        {
          text: "à partir de",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock3: [
        {
          text: "Couverture en tissus avec découpe ronde",
          style: null,
          navigationLink: null,
        },
        {
          text: "Mise en page personnalisable",
          style: null,
          navigationLink: null,
        },
        {
          text: "Jusqu’à 120 pages",
          style: null,
          navigationLink: null,
        },
        {
          text: "Format paysage",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock4: [
        {
          text: "32,90€",
          style: null,
          navigationLink: null,
        },
      ],
      images: [
        {
          desktop: {
            "1x": "https://staging5.cheerz.com/contents/assets/web_image-aqzsjfjngy9mdpx7frqeok90srkk-2x-1.jpg",
            "2x": "https://staging5.cheerz.com/contents/assets/web_image-aqzsjfjngy9mdpx7frqeok90srkk-2x-1.jpg",
          },
          webMobile: null,
        },
      ],
      label: {
        labelType: "starred",
        text: "-4%",
        color: {
          hex: "#00C1F6",
          opacityPercentage: 100,
        },
      },
      metadata: null,
      navigationLink: {
        type: "path",
        link: "products/photo-album-hardcover",
      },
      cta: null,
    },
    {
      slug: "album_4",
      backgroundColor: null,
      textBlock1: [
        {
          text: "Album Premium ouverture à plat",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock2: [
        {
          text: "à partir de",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock3: [
        {
          text: "Couverture « livre » et ouverture des pages à plat",
          style: null,
          navigationLink: null,
        },
        {
          text: "Mise en page personnalisable",
          style: null,
          navigationLink: null,
        },
        {
          text: "Jusqu’à 122 pages, papier photo argentique",
          style: null,
          navigationLink: null,
        },
        {
          text: "Format carré, portrait ou paysage",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock4: [
        {
          text: "20,90€",
          style: null,
          navigationLink: null,
        },
      ],
      images: [
        {
          desktop: {
            "1x": "https://staging5.cheerz.com/contents/assets/web_image-aqzsjfjngy9mdpx7frqeok90srkk-2x-1.jpg",
            "2x": "https://staging5.cheerz.com/contents/assets/web_image-aqzsjfjngy9mdpx7frqeok90srkk-2x-1.jpg",
          },
          webMobile: null,
        },
      ],
      label: null,
      metadata: {
        productTag: "photo-album-hardcover",
        availability: "out_of_stock",
      },
      navigationLink: {
        type: "path",
        link: "products/photo-album-hardcover",
      },
      cta: null,
    },
    {
      slug: "album_5",
      backgroundColor: null,
      textBlock1: [
        {
          text: "Mini album photo en 3 min",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock2: [
        {
          text: "à partir de",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock3: [
        {
          text: "Couverture rigide, brillante",
          style: null,
          navigationLink: null,
        },
        {
          text: "24 pages, remplissage automatique",
          style: null,
          navigationLink: null,
        },
        {
          text: "Format mini album paysage",
          style: null,
          navigationLink: null,
        },
      ],
      textBlock4: [
        {
          text: "20,90€",
          style: null,
          navigationLink: null,
        },
      ],
      images: [
        {
          desktop: {
            "1x": "https://staging5.cheerz.com/contents/assets/web_image-aqzsjfjngy9mdpx7frqeok90srkk-2x-1.jpg",
            "2x": "https://staging5.cheerz.com/contents/assets/web_image-aqzsjfjngy9mdpx7frqeok90srkk-2x-1.jpg",
          },
          webMobile: null,
        },
      ],
      label: null,
      metadata: null,
      navigationLink: {
        type: "path",
        link: "products/photo-album-hardcover",
      },
      cta: null,
    },
    {
      backgroundColor: {
        hex: "#00C1F6",
        opacityPercentage: 1,
      },
      cta: null,
      images: [
        {
          desktop: {
            "1x": "https://cdn2.chrzz.com/assets/images/product-categories/quality@2x-47470ec9.png",
            "2x": "https://cdn2.chrzz.com/assets/images/product-categories/quality@2x-47470ec9.png",
          },
          webMobile: null,
        },
      ],
      label: null,
      metadata: null,
      navigationLink: null,
      slug: "small_colored_icons_web_quality",
      textBlock1: [
        {
          navigationLink: null,
          style: null,
          text: "Qualitatif",
        },
      ],
      textBlock2: null,
      textBlock3: null,
      textBlock4: null,
    },
    {
      backgroundColor: {
        hex: "#FFC100",
        opacityPercentage: 1,
      },
      cta: null,
      images: [
        {
          desktop: {
            "1x": "https://cdn2.chrzz.com/assets/images/product-categories/custom@2x-245f1b6c.png",
            "2x": "https://cdn2.chrzz.com/assets/images/product-categories/custom@2x-245f1b6c.png",
          },
          webMobile: null,
        },
      ],
      label: null,
      metadata: null,
      navigationLink: null,
      slug: "small_colored_icons_web_customizable",
      textBlock1: [
        {
          navigationLink: null,
          style: null,
          text: "Personnalisable",
        },
      ],
      textBlock2: null,
      textBlock3: null,
      textBlock4: null,
    },
    {
      backgroundColor: {
        hex: "#FF8CBD",
        opacityPercentage: 1,
      },
      cta: null,
      images: [
        {
          desktop: {
            "1x": " https://cdn2.chrzz.com/assets/images/product-categories/original@2x-32af6b70.png",
            "2x": " https://cdn2.chrzz.com/assets/images/product-categories/original@2x-32af6b70.png",
          },
          webMobile: null,
        },
      ],
      label: null,
      metadata: null,
      navigationLink: null,
      slug: "small_colored_icons_web_original",
      textBlock1: [
        {
          navigationLink: null,
          style: null,
          text: "Original",
        },
      ],
      textBlock2: null,
      textBlock3: null,
      textBlock4: null,
    },
    {
      backgroundColor: null,
      cta: null,
      images: [],
      label: null,
      metadata: null,
      navigationLink: null,
      slug: "faq_web_1",
      textBlock1: [
        {
          navigationLink: null,
          style: null,
          text: "Quels formats d’albums photos sont disponibles ?",
        },
      ],
      textBlock2: [
        {
          navigationLink: null,
          style: null,
          text: "Nous proposons à la commande 4 formats d’albums photos différents : carré, portrait, paysage ou à fenêtre. Les 4 formats de livres photo sont déclinés en plusieurs tailles : petit ou grand carré (20×20cm, 21×21cm, 29×29cm), portrait ou paysage (15×19cm pour l’album A5, 20×27cm, 27×20cm, 21×27cm, 27×21cm) et jusqu’à 28×22cm pour l’album à fenêtre. Vous suivez encore ? Parfait ! Voilà la dernière info technique : nos albums photo disposent de 2 types d’ouverture au choix. L’ouverture layflat (ouverture du livre à plat sans marque de reliure) ou l’ouverture classique (comme un livre). Des idées de création de cadeaux photo différentes (même si il s’agit du même produit) et à tous les prix (dès 19 € 90) en fonction de toutes vos envies pour votre livre photo et de toutes les occasions pour imprimer vos beaux moments comme votre mariage par exemple.",
        },
      ],
      textBlock3: null,
      textBlock4: null,
    },
    {
      backgroundColor: null,
      cta: null,
      images: [],
      label: null,
      metadata: null,
      navigationLink: null,
      slug: "faq_web_2",
      textBlock1: [
        {
          navigationLink: null,
          style: null,
          text: "Combien de pages font les albums photos ?",
        },
      ],
      textBlock2: [
        {
          navigationLink: null,
          style: null,
          text: "Brillante question ! Ça dépend du nombre de photos que vous allez mettre dedans ! Mais par défaut, tous nos albums photos ont de 24 à 26 pages au minimum selon les modèles et les plus gros, comme l’album à fenêtre, peuvent contenir jusqu’à 120 pages. Ainsi, lors de la création à vous de choisir le nombre de photos par pages, et puis le nombre de pages pour créer un livre photo unique et qui vous ressemble pour créer le meilleur des albums photo personnalisé.",
        },
      ],
      textBlock3: null,
      textBlock4: null,
    },
    {
      backgroundColor: null,
      cta: null,
      images: [],
      label: null,
      metadata: null,
      navigationLink: null,
      slug: "faq_web_3",
      textBlock1: [
        {
          navigationLink: null,
          style: null,
          text: "Quelle est la différence entre l’ouverture classique et l’ouverture à plat (layflat) d’un album photo ?",
        },
      ],
      textBlock2: [
        {
          navigationLink: null,
          style: null,
          text: "L’album photo Layflat ne possède pas de reliure ce qui signifie, tenez vous bien, que les pages intérieures s’ouvrent entièrement à plat et sans marque pour une parfaite mise en avant de vos photos. L’album photo classique quant à lui possède une reliure traditionnelle , il s’ouvre comme un livre. Les deux livres photo sont très jolis, mais on conseille de choisir l’ouverture layflat si vous possédez beaucoup de photos au format paysage et souhaitez les mettre en pleine page (💡 petite astuce de personnalisation pour mettre en valeur vos plus belles photos). Quel que soit votre choix, créer son propre album photo de ses vacances, son mariage, une naissance... c’est un cadeau qu’il faut se faire ou un cadeau à offrir !",
        },
      ],
      textBlock3: null,
      textBlock4: null,
    },
    {
      backgroundColor: null,
      cta: null,
      images: [],
      label: null,
      metadata: null,
      navigationLink: null,
      slug: "faq_web_4",
      textBlock1: [
        {
          navigationLink: null,
          style: null,
          text: "À quelle occasion puis-je réaliser un album photo ?",
        },
      ],
      textBlock2: [
        {
          navigationLink: null,
          style: null,
          text: "Là, on a envie de vous répondre : tout le temps ! Ainsi, il n’y a pas que les grands événements qui ont droit à leur album photo personnalisé et de qualité. Les week-end entre amis, la Saint-Valentin, Noël, les vacances, un mariage, une naissance, un baptême, un anniversaire, la fête des mères, une grossesse, un brillant exploit... Un moment important dans votre vie, ou tout simplement votre quotidien (💡idée cadeau Cheerz: créez votre ",
        },
        {
          navigationLink: {
            type: "path",
            link: "products/photo-album-child",
          },
          style: null,
          text: "album photo dédié à votre enfant",
        },
        {
          navigationLink: null,
          style: null,
          text: "), toutes les occasions sont bonnes pour garder vos meilleurs souvenirs au chaud dans un bel album photo ou également juste faire des beaux cadeaux déco. Il est temps de penser au tirage de certains clichés, c’est parti ?",
        },
      ],
      textBlock3: null,
      textBlock4: null,
    },
    {
      backgroundColor: {
        hex: "#EBF3FF",
        opacityPercentage: 100,
      },
      cta: null,
      images: [],
      label: null,
      metadata: null,
      navigationLink: null,
      slug: "review-1-web",
      textBlock1: [
        {
          navigationLink: null,
          style: null,
          text: "Coucou vous, lecteur de ce petit paragraphe. Si vous lisez ceci, c'est que vous cherchez un site pour développer vos jolies photos et créer des produits exceptionnels n'est-ce-pas ? Vous êtes à la bonne adresse. Eh oui, avec Cheerz, choisissez le format que vous souhaitez parmi notre offre : Tirage photo classique, carré ou rétro, il y en a pour tous les goûts. Découvrez également nos albums photos, posters et autre décoration murales qui ont toutes trois choses en commun : le design, la qualité et la facilité de création ! Plus besoin de passer des heures en ligne à développer et faire vos albums photos, Cheerz est un site développement photo qui fait rimer rapidité et efficacité. ",
        },
      ],
      textBlock2: null,
      textBlock3: null,
      textBlock4: null,
    },
    {
      backgroundColor: null,
      cta: null,
      images: [],
      label: null,
      metadata: null,
      navigationLink: null,
      slug: "review-2-web",
      textBlock1: [
        {
          navigationLink: null,
          style: null,
          text: "Ah, et qui fait rimer bonheur et sourires garantis à l'ouverture aussi - oui oui, on est un peu des magiciens. Des magiciens de l'impression photo plus précisément, qui voulons pour vous la meilleure expérience de tous les temps. Nous avons tous tant de photos qui sont des instants uniques que vous voulez avoir, voir et revoir : voyages, vacances, week-end, mariage, voyage de noce, naissance de bébé et autres moments significatifs... C'est pour ça qu'on a créé le site photo et l'application Cheerz pour que vous gardiez tous ces précieux souvenirs avec vous pour toujours, à offrir ou vous offrir. Parce qu'entre des fichiers sur votre ordinateur et de jolis souvenirs dans vos mains, il n'y a pas photo.",
        },
      ],
      textBlock2: null,
      textBlock3: null,
      textBlock4: null,
    },
  ],
};

export const largeProductCardsSection = category.sections.filter((section) => {
  return section.displayType === "large_product_cards_web";
})[0];

export const largeProductCardsTiles = category.tiles.filter((tile) =>
  largeProductCardsSection.tileSlugs.includes(tile.slug)
);

export const smallColoredIconsSection = category.sections.filter((section) => {
  return section.displayType === "small_colored_icons_web";
})[0];

export const smallColoredIconsTiles = category.tiles.filter((tile) =>
  smallColoredIconsSection.tileSlugs.includes(tile.slug)
);

export const seoDescriptionSection = category.sections.filter(
  (section) => section.displayType === "seo_description_web"
)[0];

export const seoDescriptionTiles = category.tiles.filter((tile) =>
  seoDescriptionSection.tileSlugs.includes(tile.slug)
);

export const faqSection = category.sections.filter((section) => {
  return section.displayType === "faq_web";
})[0];

export const faqTiles = category.tiles.filter((tile) => faqSection.tileSlugs.includes(tile.slug));
